import { NgModule } from '@angular/core';
import { UsageComponent } from './usage.component';
import { SharedModule } from 'app/modules/shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { DateRangeModule } from '../../date-range/date-range.module';
import { DataExportModule } from '../../data-export/data-export.module';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [UsageComponent],
  imports: [
    SharedModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatIconModule,
    DateRangeModule,
    DataExportModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule
  ],
  exports: [UsageComponent]
})
export class UsageModule { }
